import { render, staticRenderFns } from "./submit_claims.vue?vue&type=template&id=3604c1a9"
import script from "./submit_claims.vue?vue&type=script&lang=js"
export * from "./submit_claims.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports